import { requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'

export const getAllEventCodes = (user) => {
  return requestWithPromise(
    '/api/event-codes-types',
    HttpMethods.GET,
    null,
    user
  ).then(json => {
    return json?.data ?? []
  })
}
